import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { PersononboardConstantsService } from './persononboard-constants.service';
import { BaseService } from '../../shared/services/base.service';

@Injectable()
export class PersononboardService {
  public updatedActionData: any;
  
  public setUpdatedData(data, actionType) {
    switch (actionType) {
      
      case 'UpdateAction':
        this.updatedActionData = data;
        break;

    }
  }
  public getUpdatedData(actionType) {
    switch (actionType) {
     
      case 'UpdateAction':
        return this.updatedActionData;
    }
  }


  currentPersonOnBoardRequestId: number;
  currentPersonOnBoardPageIndex: string;
  public setcurrentPersonOnBoardRequestId(obsId) {
    this.currentPersonOnBoardRequestId = obsId;
  }
  public getcurrentPersonOnBoardRequestId() {
    return this.currentPersonOnBoardRequestId;
  }

  public setcurrentPersonOnBoardPageIndex(pageId) {
    this.currentPersonOnBoardPageIndex = pageId;
  }
  public getcurrentPersonOnBoardPageIndex() {
    return this.currentPersonOnBoardPageIndex;
  }
  getAllPassRequests() {
    return JSON.parse(this.baseService.getItemFromSession('passRequests'));
  }
  setAllPassRequests(passRequests) {
    this.baseService.setItemInSession('passRequests', JSON.stringify(passRequests));
  }
  getAllPOBRequests() {
    return JSON.parse(this.baseService.getItemFromSession('pobRequests'));
  }
  setAllPOBRequests(pobRequests) {
    this.baseService.setItemInSession('pobRequests', JSON.stringify(pobRequests));
  }
  constructor(private dataService: DataService, private baseService: BaseService) { }

  SaveorUpdatePassRequest(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.SaveorUpdatePassRequest, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }

  getHSECheckDocuments(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetHSECheckDocuments, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getPrerequisiteConfiguration(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPrerequisiteConfiguration, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  searchAccesspassOverview(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.SearchAccesspassOverview, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }
  getPOBResponseDetails(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPOBResponseDetails, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getPassRequestStatus(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPassRequestStatus, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getPassRequestStatusDoneFilter(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPassRequestStatusDoneFilter, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getPassRequestDetailsByPassRequestId(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPassRequestId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getDownListOfUser(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetDownListOfUser, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  UpdatePassRequest(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.UpdatePassRequest, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }

  contractHolderStatus(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.ContractHolderStatus, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  insertCheckInCheckOutDetails(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.InsertCheckInCheckOutDetails, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }
  getPOBListOverviewDetails(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPOBListOverviewDetails, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }
  getDailyPOBListOverviewDetails(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetDailyPOBListOverviewDetails, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }
  getPassRequestReportDetails(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPassRequestReportDetails, model)
      .subscribe(Response => {
        callbackMethod(Response);
      });
  }
  getPassRequestDetailsByEmailId(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPassRequestDetailsByEmailId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getExportToExcelPassRequests(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetExportToExcelPassRequests, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  exportToExcelPOBRequests(model, callbackMethod) {
    this.dataService.postHttpResponse(PersononboardConstantsService.APIURL.GetExportToExcelPOBRequests, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse(PersononboardConstantsService.APIURL.DownloadPDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  downloadZIP(model, callbackMethod) {
    this.dataService.postHttpResponse(PersononboardConstantsService.APIURL.DownloadZIP, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getApprovals(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetApprovals, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  setApprovals(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.SetApprovals, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getPassRequestDetailsByPassId(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.GetPassRequestDetailsByPassId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

	renewPass(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.RenewPass, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  recreatePrintPass(model, callbackMethod) {
    this.dataService.post(PersononboardConstantsService.APIURL.RecreatePrintPass, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}
